export const theme = {
  breakpoint: {
    xm: "320px",
    sm: "600px",
    md: "1008px",
    lg: "1280px",
  },
  color: {
    blue: "#0033e8",
    black: "#262626",
    lightBlue: "#99adff",
    neutral15: "#21242c",
    neutral20: "#2b303b",
    neutral25: "#363c49",
    neutral32: "#404653",
    neutral42: "#58627d",
    neutral50: "#6c7893",
    neutral55: "#7b869d",
    neutral65: "#98a1b3",
    neutral80: "#c4c9d4",
    neutral206: "#CECECE",
    neutral90: "#e2e4e9",
    neutral95: "#f0f2f4",
    white: "#fff",
  },
  space: {
    xxxs: "2px",
    xxs: "4px",
    xs: "8px",
    s: "12px",
    m: "16px",
    l: "24px",
    xl: "32px",
    xxl: "64px",
  },
} as const

export type Theme = typeof theme
